import React, { Component } from 'react'
import Meta from 'components/layout/Meta';
import {actions} from "components/page/pageModule";

import './index.scss'

class ShangCe extends Component {

  constructor(props) {
    super(props)
    this.state = {
      current: 0,
      array: [
        {name: '公共文件'},
        {name: '决策组件'},
        {name: '决策管理流程化'},
        {name: '决策调试'},
      ]
    };
  }

  render() {

    return (
      <div className="servicesWrap">
        <Meta location={this.props.location} title=""/>
        <div className="banner sc_banner">
          <div className="banner_cont">
            <h1>策略引擎 – 上策</h1>
            <p>上策智能决策引擎是中腾信根据多年实战经验自主研发的决策引擎，提供规则集、决策表、决策树和决策流等多种可视化的规则设计工具。在不同业务场景下任意灵活的调配规则，并支持快速热部署，以实现准入预授信、实时授信决策、催收预警等模型策略管理及优化，贯穿信贷各个生命周期，实现全流程风险管理。</p>
            <a href="./services/submitform">方案咨询</a>
          </div>
        </div>
        <div className="wrapPanel panelCol">
          <div className="panel sc_panel">
            <h2><span>产品优势</span></h2>
            <ul className="sc_panel_ul">
              <li>
                <img src={require('./images/icon_8.png')}/>
                <h3>快速响应变化的决策</h3>
                <p>面对日益变化的业务需求，支持全新或调优的决策快速上线，将动辄数月的开发周期缩短至数日。</p>
                <dl>
                  <dd>向导式规则集</dd>
                  <dd>灵活的数据结构</dd>
                  <dd>决策流、决策树、决策表</dd>
                </dl>
              </li>
              <li>
                <img src={require('./images/icon_9.png')}/>
                <h3>决策作为核心资产统一化管理</h3>
                <p>决策作为公司核心内容，将业务决策剥离“固化”系统，统一维护在决策引擎，进行透明高效的决策管理。</p>
                <dl>
                  <dd>版本控制</dd>
                  <dd>热发布机制</dd>
                  <dd>自测自发布</dd>
                  <dd>快速部署上规则</dd>
                </dl>
              </li>
              <li>
                <img src={require('./images/icon_10.png')}/>
                <h3>便捷的规则开发</h3>
                <p>提供多种可视化决策组件，且支持灵活的数据结构，规则编写简单便捷，非技术业务用户也可直接参与策略运营。</p>
                <dl>
                  <dd>变量信息统一管理</dd>
                  <dd>决策统一管理，共享决策库</dd>
                  <dd>提供强大针对决策的可视化模拟分析工具，规则迅速调优</dd>
                </dl>
              </li>
            </ul>
          </div>
        </div>
        <div className="wrapPanel">
          <div className="panel sc_panel">
            <h2><span>特色功能</span></h2>

            <div className="tab">
              <ul className="tab-head">
                {
                  this.state.array.map((element,idx) => {
                    return (
                      <li key={idx} onClick={ () => { this.setState({ current: idx }) } } className={ this.itemNav(idx) }>
                        <i className={ 'icon icon' + idx }></i>
                        { element.name }
                      </li>
                    )
                  })
                }
              </ul>

              <div className="tab-content">

                <div className={ this.itemCon(0) }>
                  <h4>公共文件</h4>
                  <p>变量、自定义函数、常量等信息统一管理，赋予权限的人员均可引用公共文件，极大程度节省重复工作量</p>
                </div>

                <div className={ this.itemCon(1) }>
                  <h4>决策组件</h4>
                  <p>向导式规则集：由普通规则和循环规则组成，规则编写页面有强大的工具栏，工具栏将复杂的逻辑简单化，通过简单输入或借助工具栏工具，即可完成复杂的规则编写</p>
                  <p>决策表：以一种表格形式表现业务规则，通过简单输入或借助工具栏工具，可以快速定义出层级清晰的决策表</p>
                  <p>评分卡：通过多维度定义目标对象的属性，按照规则区间设置条件，即可实现对目标对象的评分计算</p>
                  <p>规则流：以流程图的形式对已有的规则集、决策表、评分卡进行编排，连线既可以定义条件，亦可以完成冠军/挑战者模式，以流程化的方式运行一个大的复杂的业务规则</p>
                </div>

                <div className={ this.itemCon(2) }>
                  <h4>决策管理流程化</h4>
                  <p>根据多年实战经验，总结出一套最符合业务人员的决策管理流程，按照系统既定流程可准确快速地完成全套专家级决策的编写、管理</p>
                </div>
                <div className={ this.itemCon(3) }>
                  <h4>决策调试</h4>
                  <p>编写规则的同时，可以借助强大的针对经营指标的可视化模拟分析工具，可以帮助业务人员更有针对性的修改和优化规则。奕快速将现有专家模型导入系统进行验证与使用，新晋业务人员也可以快速制定出专家级决策。</p>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="wrapPanel fa_wrap">
          <div className="panel sc_panel paddingTop">
            <h2><span>应用场景</span></h2>
            <ul className="apply_ul">
              <li>
                <img src={require('./images/pro_12.png')}/>
                <div>
                  <h4>金融领域</h4>
                  <span>可应用于申请审批、贷中动态监控和预警、贷后催收策略、征信数据分析等业务场景</span>
                </div>
              </li>
              <li>
                <img src={require('./images/pro_13.png')}/>
                <div>
                  <h4>保险领域</h4>
                  <span>部署各类模型，可应用于新契约核保规则、理赔平台的核保规则等业务场景</span>
                </div>
              </li>
              <li>
                <img src={require('./images/pro_14.png')}/>
                <div>
                  <h4>非金融领域</h4>
                  <span>各行业客户营销活动，灵活配置精准营销的规则；根据用户各类信息、行为等建立用户识别模型，制定防薅羊毛的营销策略;电商促销活动的风险控制</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

      </div>
    )
  }

  itemNav = (index) => {
    return index === this.state.current ? 'active' : '';
  }

  itemCon = (index) => {
    return index === this.state.current ? 'active' : '';
  }

}


export default ShangCe



// WEBPACK FOOTER //
// ./modules/services/ShangCe.js